import { ready_admin } from "./admin/manage.js";
import {copyToClipBoard, whenReady} from './utils.js';
import alertify from 'alertifyjs';
import {Api} from './api.js';

let ready_main = function ($element) {
  $element = $($element);
  // $element.find(".table-fix").fixMe();

  $element.find("[r]").on("click mouseover", function () {
    $(this).attr("href", $(this).attr("r")).removeAttr("r").unbind();
  });

  $element.find(".click-fade").on("click", function () {
    $(this).fadeOut();
  });
  $element.find(".click-hide").on("click", function () {
    $(this).hide();
  });

  $element
    .find('a[href*="#"]')
    .not('[href="#"]')
    .not("[data-toggle]")
    .not('[href="#0"]')
    .on("click", function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
        location.hostname === this.hostname
      ) {
        // Figure out element to scroll to
        let target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          event.preventDefault();
          target._scrollTo();
        }
      }
    });

  $element.find(".img").each(function () {
    if ($(this).attr("class").trim() === "img") {
      // || $(this).hasClass('img_slide')) {
      wall(this);
    }
  });

  $element.find("[hreftarget]").each(function () {
    let $target = $(this);
    let $hreflang = $("[hreflang='" + $target.attr("hreftarget") + "']");
    $target.attr("href", $hreflang.attr("href")).removeClass("hidden");
  });

  $element.find("[insert-empty-to]").on("click", function () {
    let $target = $(this).attr("insert-empty-to");
    $("[name='" + $target + "']")
      .val("[empty]")
      .trigger("change");
  });
  $element.find("[faholder]").each(function () {
    let $placeholder = $(this).attr("faholder");
    $placeholder = $("<textarea/>").html($placeholder).text();
    $(this).attr("placeholder", unescape($placeholder));
  });
};

(function ($) {
  $.fn.lazyImage = function (threshold, callback) {
    let $w = $(window),
      th = threshold || 0,
      retina = window.devicePixelRatio > 1,
      attrib = retina ? "data-src-retina" : "data-src",
      images = this,
      loaded;

    this.one("lazyImage", function () {
      let source = this.getAttribute(attrib);
      source = source || this.getAttribute("data-src");
      if (source) {
        this.setAttribute("src", source);
        $(this).fadeTo(1, 1, function () {
          this.removeAttribute("data-src");
        });
        if (typeof callback === "function") callback.call(this);
      }
    });

    function lazyImage() {
      let inview = images.filter(function () {
        let $e = $(this);
        if ($e.is(":hidden")) return;

        let wt = $w.scrollTop(),
          wb = wt + $w.height(),
          et = $e.offset().top,
          eb = et + $e.height();

        return eb >= wt - th && et <= wb + th;
      });

      loaded = inview.trigger("lazyImage");
      images = images.not(loaded);
    }

    $w.on("scroll.lazyImage resize.lazyImage lookup.lazyImage", lazyImage);

    lazyImage();

    return this;
  };
})(window.jQuery || window.Zepto);

let Link = {
  js: function ($src, $callback) {
    $.getScript($src, $callback);
  },
  css: function ($src) {
    $("<link>", { rel: "stylesheet", type: "text/css", href: $src }).appendTo(
      "head"
    );
  },
};

jQuery.fn.extend({
  _scrollTo: function () {
    return this.each(function () {
      let $target = $(this);
      $("html, body").animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        1000,
        function () {
          $target.trigger("focus");
          if ($target.is(":focus")) {
            // Checking if the target was focused
            return false;
          } else {
            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
            $target.trigger("focus"); // Set focus again
          }
        }
      );
    });
  },
});

//Удаление пустых query params
$(document).on("submit", function () {
  $(this)
    .find("input")
    .filter(function () {
      return !this.getAttribute('data-preserve-empty') && !$.trim(this.value).length; // get all empty fields
    })
    .prop("disabled", true);
}) +
  // DROPDOWN CLASS DEFINITION 3.3.5
  (function ($) {
    "use strict";

    let backdrop = ".dropdown-backdrop";
    let toggle = '[data-toggle="dropdown"]';
    let Dropdown = function (element) {
      $(element).on("click.bs.dropdown", this.toggle);
    };

    function getParent($this) {
      let selector = $this.attr("data-target");

      if (!selector) {
        selector = $this.attr("href");
        selector =
          selector &&
          /#[A-Za-z]/.test(selector) &&
          selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
      }

      let $parent = selector && $(selector);

      return $parent && $parent.length ? $parent : $this.parent();
    }

    function clearMenus(e) {
      if (e && e.which === 3) return;
      $(backdrop).remove();
      $(toggle).each(function () {
        let $this = $(this);
        let $parent = getParent($this);
        let relatedTarget = { relatedTarget: this };

        if (!$parent.hasClass("open")) return;

        if (
          e &&
          e.type === "click" &&
          /input|textarea/i.test(e.target.tagName) &&
          $.contains($parent[0], e.target)
        )
          return;

        $parent.trigger((e = $.Event("hide.bs.dropdown", relatedTarget)));

        if (e.isDefaultPrevented()) return;

        $this.attr("aria-expanded", "false");
        $parent
          .removeClass("open")
          .trigger("hidden.bs.dropdown", relatedTarget);
      });
    }

    Dropdown.prototype.toggle = function (e) {
      let $this = $(this);

      if ($this.is(".disabled, :disabled")) return;

      let $parent = getParent($this);
      let isActive = $parent.hasClass("open");

      clearMenus();

      if (!isActive) {
        if (
          "ontouchstart" in document.documentElement &&
          !$parent.closest(".navbar-nav").length
        ) {
          // if mobile we use a backdrop because click events don't delegate
          $(document.createElement("div"))
            .addClass("dropdown-backdrop")
            .insertAfter($(this))
            .on("click", clearMenus);
        }

        let relatedTarget = { relatedTarget: this };
        $parent.trigger((e = $.Event("show.bs.dropdown", relatedTarget)));

        if (e.isDefaultPrevented()) return;

        $this.trigger("focus").attr("aria-expanded", "true");

        $parent.toggleClass("open").trigger("shown.bs.dropdown", relatedTarget);
      }

      return false;
    };

    Dropdown.prototype.keydown = function (e) {
      if (
        !/(38|40|27|32)/.test(e.which) ||
        /input|textarea/i.test(e.target.tagName)
      )
        return;

      let $this = $(this);

      e.preventDefault();
      e.stopPropagation();

      if ($this.is(".disabled, :disabled")) return;

      let $parent = getParent($this);
      let isActive = $parent.hasClass("open");

      if ((!isActive && e.which != 27) || (isActive && e.which == 27)) {
        if (e.which == 27) $parent.find(toggle).trigger("focus");
        return $this.trigger("click");
      }

      let desc = " li:not(.disabled):visible a";
      let $items = $parent.find(".dd-m" + desc);

      if (!$items.length) return;

      let index = $items.index(e.target);

      if (e.which == 38 && index > 0) index--; // up
      if (e.which == 40 && index < $items.length - 1) index++; // down
      if (!~index) index = 0;

      $items.eq(index).trigger("focus");
    };

    // DROPDOWN PLUGIN DEFINITION
    function Plugin(option) {
      return this.each(function () {
        let $this = $(this);
        let data = $this.data("bs.dropdown");

        if (!data) $this.data("bs.dropdown", (data = new Dropdown(this)));
        if (typeof option === "string") data[option].call($this);
      });
    }

    let old = $.fn.dropdown;

    $.fn.dropdown = Plugin;
    $.fn.dropdown.Constructor = Dropdown;

    // DROPDOWN NO CONFLICT
    $.fn.dropdown.noConflict = function () {
      $.fn.dropdown = old;
      return this;
    };

    // APPLY TO STANDARD DROPDOWN ELEMENTS
    $(document)
      .on("click.bs.dropdown.data-api", clearMenus)
      .on("click.bs.dropdown.data-api", ".dropdown form", function (e) {
        e.stopPropagation();
      })
      .on("click.bs.dropdown.data-api", toggle, Dropdown.prototype.toggle)
      .on("keydown.bs.dropdown.data-api", toggle, Dropdown.prototype.keydown)
      .on("keydown.bs.dropdown.data-api", ".dd-m", Dropdown.prototype.keydown);
  })(jQuery);

function ready($target) {
  ready_main($target);
  ready_admin($target);
}

async function inputActionsHandler(target) {
  const input = target.parentElement.previousElementSibling.getElementsByTagName("input")[0];

  switch (target.dataset.actionType) {
    case "copy":
      await copyToClipBoard(input.value);
      alertify.success("text copied");
      break;
    case "link":
      try {
        const url = new URL(input.value);
        window.open(input.value, '_blank').focus();
      } catch (exception) {
        alertify.error("Invalid url");
      }
      break;
    case "show":
      if (input.type === "password") {
        input.type = "text";
        target.classList.add("fa-eye-slash");
        target.classList.remove("fa-eye");
      } else {
        input.type = "password";
        target.classList.add("fa-eye");
        target.classList.remove("fa-eye-slash");
      }

      break;
    default:
      console.log("unknown action type");
  }
}

async function select2ActionsHandler(target) {
  const values = target.parentElement.previousElementSibling.getElementsByTagName(
      "ul")[0].children;
  const text = Array.from(values).reduce(
      (prev, current) => prev +
          current.getAttribute("title") + ',',
      ""
  );

  switch (target.dataset.actionType) {
    case "copy":
      await copyToClipBoard(text);
      alertify.success("text copied");
      break;
    default:
      console.log("unknown action type");
  }
}

whenReady(() => {
  ready(document);

	// redirect to sequence update by middle mouse click on select2
	document.getElementsByName("sequences[]").forEach((element) => {
		element.parentElement.addEventListener("mousedown", (e) => {
			if (e.button === 1) {
				e.stopPropagation();
				e.preventDefault();

				const element =
						e.target.tagName === "BUTTON"
								? e.target.nextElementSibling
								: e.target.parentElement.nextElementSibling;

				const sequenceId = element.id.substring(element.id.lastIndexOf("-") + 1);
				window.open("/sequence/update/" + sequenceId);
			}
		});
	});

  // handler for autosave form
  document.querySelectorAll("form[autosave]").forEach(form => {
    const action = form.getAttribute("action");
    const csrfToken = document.querySelector('input[name="_csrf"]').value;

    $(form).find("input,textarea,select").on("change", async (e) => {
      const $target = $(e.target);
      const fieldName = $target.attr("name");
      const formGroup = e.target.closest(".form-group");
      const value = e.target.type === "checkbox" ? Number(e.target.checked) : $target.val();

      try {
          await Api.sendFormField(action, csrfToken, fieldName, value);
	      formGroup.querySelector(".help-block").textContent = '';
	      formGroup.classList.add('has-success');
	      formGroup.classList.remove('has-error');
      } catch (ex) {
	      formGroup.querySelector(".help-block").textContent = ex.message
	      formGroup.classList.add('has-error');
	      formGroup.classList.remove('has-success');
      }
    });
  });

  // select2 action buttons handler
  document.querySelectorAll(".select2-actions button").forEach(button => {
    button.addEventListener("click", async e => {
      await select2ActionsHandler(e.target);
    });

    button.addEventListener("mouseenter", e => {
      const input = e.target.parentElement.previousElementSibling.querySelector(
          ".select2-selection");
      input.style.borderColor = "#5a4165";
    });

    button.addEventListener("mouseleave", e => {
      const input = e.target.parentElement.previousElementSibling.querySelector(
          ".select2-selection");
      input.style.borderColor = "";
    });
  });

  // input action buttons handler
  document.querySelectorAll(".input-actions button").forEach(button => {
    button.addEventListener("click", async e => {
      await inputActionsHandler(e.target);
    });

    button.addEventListener("mouseenter", e => {
      const input = e.target.parentElement.previousElementSibling.getElementsByTagName(
          "input")[0];
      input.style.borderColor = "#5a4165";
    });

    button.addEventListener("mouseleave", e => {
      const input = e.target.parentElement.previousElementSibling.getElementsByTagName(
          "input")[0];
      input.style.borderColor = "";
    });
  });

	const iframeDoc = document.querySelector(".iframe-doc");
	if (iframeDoc) {
		const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

		alignFrameToCenter(isFirefox);

		window.addEventListener('resize', () => alignFrameToCenter(isFirefox));
		iframeDoc.closest('.wrapper').classList.add('iframe-wrapper');
		document.querySelector('.topBar')?.classList.add('topBar_yellow');
		document.body.style.overflow = 'hidden'

		if (isFirefox) {
			iframeDoc.classList.add("mt-5");
		}

		function alignFrameToCenter(isFirefox) {
			const margin = (document.body.clientWidth - 774) / 2 + "px";

			if (isFirefox) {
				iframeDoc.style.marginLeft = margin
			} else {
				iframeDoc.setAttribute('marginwidth', margin);
			}
		}
	}

	document.querySelectorAll("[data-with-input-length]").forEach(elem => {
		const input = document.getElementById(elem.getAttribute("for"));
		const fieldLengthLabel = elem.getElementsByTagName("sup")[0];
		fieldLengthLabel.innerHTML = input.value.length;

		input.addEventListener("input", e => {
			fieldLengthLabel.innerHTML = e.target.value.length;
		});
	});

	document.querySelectorAll("*[id^='delete-track-']").forEach(button => {
		button.addEventListener("click", async e => {
			if (!confirm('Are you sure you want to delete this item?')) {
				return;
			}

			try {
              await Api.deleteTrack(button.dataset.trackId);

              button.closest("tr").remove();

              alertify.success("Track has been removed");
			} catch (e) {
              alertify.error(e.message);
            }
        });
	});

  document.querySelectorAll("*[id^='delete-sequence-']").forEach(button => {
    button.addEventListener("click", async e => {
	    if (!confirm('Are you sure you want to delete this item?')) {
		    return;
	    }

      try {
        await Api.deleteSequence(button.dataset.sequenceId);

        button.closest("tr").remove();

        alertify.success("Sequence has been removed");
      } catch (e) {
        alertify.error(e.message);
      }
    });
  });

	document.querySelectorAll('*[id^="sync-video-metadata-"]').forEach(elem => {
		elem.addEventListener("click", async (event) => {
			const sequenceId = event.currentTarget.dataset.sequenceId;
			const sequenceType = event.currentTarget.dataset.sequenceType;

			try {
				await Api.syncVideoMetadata(sequenceId, sequenceType);
				alertify.success("Sequence sync successfully");
			} catch (e) {
				alertify.error(e.message);
			}
		});
	});

	document.getElementById("export-all-tracks-lists")?.addEventListener('click', async e => {
		try {
			await Api.exportAllTracksLists();
			alertify.success("Export tracks lists successfully");
		} catch (e) {
			alertify.error(e.message);
		}
	});

    document.getElementById('table-search-btn')?.addEventListener('click', e => {
	    $('.grid-view').yiiGridView("applyFilter");
    });
});